import axios from 'axios';
import BaseAPI from './base/base-api';

class UserSetupAPI extends BaseAPI {
	constructor() {
		super();
	}
	urlName = 'InvoiceBotsAPI';
	controllerName = 'usersetup';
}

export default new UserSetupAPI();
